import { render } from "./Dobra.vue?vue&type=template&id=4b262964"
import script from "./Dobra.vue?vue&type=script&lang=js"
export * from "./Dobra.vue?vue&type=script&lang=js"

import "./Dobra.vue?vue&type=style&index=0&id=4b262964&lang=css"
script.render = render

export default script